<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item active" aria-current="page">
      <a [routerLink]="'/translation/bot-prompts'">Bot Prompts</a>
    </li>
    <li class="breadcrumb-item" aria-current="page">
      @if (isCreate()) {
        <span class="fs-5 fw-bold mb-0">Add bot prompt</span>
      } @else {
        <span class="fs-5 fw-bold mb-0">Edit bot prompt</span>
      }
    </li>
  </ol>
</nav>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="row g-3 mb-3">
        <div class="col">
          <label for="name" class="form-label">Name</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-building"></i></span>
            <input type="text" class="form-control" id="name" placeholder="Prompt name" formControlName="name">
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col">
          <label for="prompt" class="form-label">Prompt</label>
          <div class="input-group">
            <span class="input-group-text"><i class="bi bi-person"></i></span>
            <textarea type="text" class="form-control" id="prompt" placeholder="Describe exactly how the AI should behave and treat the text to translate." formControlName="prompt" rows="10"></textarea>
          </div>
        </div>
      </div>

      <div class="col-12 text-end mt-5">
        <button type="submit" class="btn btn-primary fw-bold" [disabled]="!canUpdate()">
          @if (isCreate()) {
            Create
          } @else {
            Update
          }
        </button>
      </div>

    </form>
  </div>
</div>
